<div class="px-3 md:px-10 xl:px-[175px]" *transloco="let t">
    <div
        class="text-quaternary text-font36px leading-[40px] aspect43:text-font65px aspect43:leading-[75px] font-normal">
        <div class="max-w-[100%] aspect43:w-[1272px] ">
            <h1 class="!text-black text-font32px font-bold font-sans">{{ pageH1 }}</h1>
            <h2 class="font-medium text-font24px text-[#364349]">{{ pageSubtitle }}</h2>
        </div>
    </div>

   

    <div class="flex flex-wrap w-full gap-5 mt-7 items-center mb-[31px] relative">
        <div class="relative h-[56px] w-full md:flex-1"><input (keypress)="newFiltersToApply = true;inputEnter($event)"
                [(ngModel)]="search" placeholder="  Usa parole chiave per una ricerca più chiara e immediata..."
                class="h-[56px] w-full placeholder:text-[#719CFF] text-font18px text-[#719CFF] bg-Swhite pl-[65px] pr-10 py-[11px] gap-2.5 flex rounded-full"
                style="box-shadow: 2px 4px 12px 2px rgba(0, 26, 255, 0.04);border:2px solid rgb(211 224 255) !important">
            <svg class="absolute left-[24px] top-[16px]" width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
                    stroke="#719CFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M22 22L20 20" stroke="#719CFF" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
            @if(search){<div (click)="search = '';applyFilters()" class="absolute cursor-pointer right-4 top-4" ><svg xmlns="http://www.w3.org/2000/svg" height="24p" width="24px" viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d="M504.6 148.5C515.9 134.9 514.1 114.7 500.5 103.4C486.9 92.1 466.7 93.9 455.4 107.5L320 270L184.6 107.5C173.3 93.9 153.1 92.1 139.5 103.4C125.9 114.7 124.1 134.9 135.4 148.5L278.3 320L135.4 491.5C124.1 505.1 125.9 525.3 139.5 536.6C153.1 547.9 173.3 546.1 184.6 532.5L320 370L455.4 532.5C466.7 546.1 486.9 547.9 500.5 536.6C514.1 525.3 515.9 505.1 504.6 491.5L361.7 320L504.6 148.5z"/></svg></div>}

        </div>

        <div class="w-full md:w-fit cursor-pointer h-12 items-center flex gap-[5px]"> 
            <std-select customClassContaier="custom-select" class="h-full w-full md:w-[250px]"
                customClassContainerElement="max-h-[250px] overflow-y-scroll change-cammel-case custom-scrollbar"
                [filterable]="false" [currentValue]="currentSearch"
                (onChangeValue)="newFiltersToApply = true;changeFilters($event,'exact')" [placeholder]="'Tipo ricerca'"
                [data]="searchList" bindValue="value"></std-select>
        </div>

        <div (click)="showFilters = !showFilters"
            class="basis-full md:basis-auto w-full md:w-fit md:basis-auto cursor-pointer h-12 items-center px-[17px] flex justify-center gap-[5px] rounded-full border-[#283759] border-[2px] bg-[#D3E0FF] whitespace-nowrap">            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.6187 4.64346C21.5033 4.37675 21.312 4.14986 21.0686 3.99101C20.8253 3.83216 20.5406 3.74836 20.25 3.75002H3.74997C3.45966 3.7506 3.17575 3.8354 2.93269 3.99416C2.68962 4.15291 2.49785 4.37879 2.38063 4.64438C2.26341 4.90998 2.22579 5.20389 2.27232 5.49045C2.31886 5.77701 2.44755 6.04391 2.64279 6.25877L2.65029 6.26721L8.99998 13.0472V20.25C8.99991 20.5215 9.07353 20.7879 9.21297 21.0208C9.35241 21.2538 9.55246 21.4445 9.79178 21.5727C10.0311 21.7008 10.3007 21.7617 10.5719 21.7486C10.843 21.7356 11.1056 21.6493 11.3315 21.4988L14.3315 19.4981C14.5372 19.3612 14.7058 19.1755 14.8224 18.9576C14.939 18.7398 15 18.4965 15 18.2494V13.0472L21.3506 6.26721L21.3581 6.25877C21.5554 6.04489 21.6853 5.77764 21.7317 5.49037C21.778 5.2031 21.7387 4.90854 21.6187 4.64346ZM13.7043 12.2419C13.5746 12.3795 13.5016 12.5609 13.5 12.75V18.2494L10.5 20.25V12.75C10.5 12.5596 10.4276 12.3762 10.2975 12.2372L3.74997 5.25002H20.25L13.7043 12.2419Z"
                    fill="#283759" />
            </svg>
            <div class="text-[#283759] text-sm md:text-font18px whitespace-nowrap">{{showFilters ? 'Nascondi filtri' : 'Mostra filtri'}}</div>




        </div>
        <!-- @if(numberOfFilters > 2){
            <div class="text-[#283759] text-font18px font-medium cursor-pointer" (click)="resetFilters()">Reset</div>
        } -->
    </div>

    @if(showFilters){
    <div class="mb-5 flex gap-2.5 flex-wrap max-w-[100%] mx-auto">
        @if(resettingFilters){ @for (filter of filters; track $index) {
        @if(filter.name != 'status'){<div class="w-full md:w-[300px] relative">
            <std-select customClassContaier="custom-select"
                customClassContainerElement="max-h-[250px] overflow-y-scroll change-cammel-case custom-scrollbar"
                [filterable]="true" (onChangeValue)="newFiltersToApply = true;changeFilters($event,filter.name)"
                [showMultipleSelection]="false" [multiple]="true" [placeholder]="t(filter.name)" [data]="filter.labels"
                bindLabel="name" bindValue="id" [closeOnSelection]="false"></std-select>
        </div>}
        <!-- @if(filter.name == 'status'){<div class="w-full aspect43:w-[300px] relative">
        
        <std-select customClassContaier="custom-select"
            customClassContainerElement="max-h-[250px] overflow-y-scroll change-cammel-case custom-scrollbar"
            [filterable]="true" [currentValue]="{label:'Aperto'}" (onChangeValue)="newFiltersToApply = true;changeFilters($event,filter.name)"
             [label]="t(filter.name)" [placeholder]="t(filter.name)"
            [data]="filter.labels" bindLabel="label" bindValue="label"></std-select>
    </div>} -->
        }}
        <!-- @for (item of baseFilters; track $index) {
    <div (click)="baseFiltersIndex == $index ? baseFiltersIndex = -1 : baseFiltersIndex = $index"
        style="box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.07)"
        class="p-[14px] aspect43:px-5 aspect43:py-[18px] text-font14px aspect43:text-font18px text-quaternary h-[46px] aspect43:h-[60px] select-none bg-primary bg-opacity-60 rounded-full font-medium cursor-pointer"
        [ngClass]="{'!bg-opacity-100 !bg-quaternary !text-Swhite': baseFiltersIndex == $index}">{{item.name}}</div>
    } -->
    </div>
    <div class="mb-[30px] flex gap-2.5 flex-wrap max-w-[100%] mx-auto">
        <!-- @for (item of normalFilters; track $index) {
    <div (click)="addNormalFilter($index)" style="box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.07)"
        class="p-[14px] aspect43:px-5 aspect43:py-[18px] text-font14px aspect43:text-font18px !border-[1px] border-Swhite select-none text-quaternary h-[46px] aspect43:h-[60px] bg-Swhite bg-opacity-60 rounded-full font-medium cursor-pointer"
        [ngClass]="{' !border-quaternary': normalFiltersIndexs.includes($index)}">{{item.name}}</div>
    } -->
    </div>
    <div class="md:hidden place-content-end gap-5 items-center mb-5 max-w-[100%] mx-auto">
        @if(resettingFilters){
        <div class="w-full md:w-[300px] relative">

            <std-select customClassContaier="custom-select"
                customClassContainerElement="max-h-[250px] overflow-y-scroll change-cammel-case custom-scrollbar"
                [filterable]="true" (onChangeValue)="newFiltersToApply = true;changeFilters($event,'order')"
                [placeholder]="'Seleziona ordinamento'"
                [data]="[{value:1,label:'Data apertura recente'},{value:2,label:'Data apertura meno recente'},{value:3,label:'Data chiusura recente'},{value:4,label:'Data chiusura meno recente'}]"
                bindLabel="label" bindValue="value"></std-select>
        </div>
        <div class="w-full md:w-[300px] relative">

            <std-select customClassContaier="custom-select"
                customClassContainerElement="max-h-[250px] overflow-y-scroll change-cammel-case custom-scrollbar"
                [filterable]="true" [currentValue]="currentStatus"
                (onChangeValue)="newFiltersToApply = true;changeFilters($event,'status')" [placeholder]="'Status'"
                [data]="status" bindLabel="label" bindValue="label"></std-select>
        </div>}

    </div>
    }

 <div class="w-full border-t-2 border-blue-500 my-5"></div> 

 <br>
    <div class="md:flex md:w-fit ml-auto items-center mb-5 gap-5">
        
        @if(lastSearch && lastSearch.length > 0) {
        <div class="w-full md:w-fit cursor-pointer my-5 md:my-0 h-12 items-center md:px-[5px] flex gap-[5px]">
            <std-select customClassContaier="custom-select" class="h-full w-full md:w-[250px]"
                customClassContainerElement="max-h-[250px] overflow-y-scroll change-cammel-case custom-scrollbar"
                [filterable]="false" [currentValue]="lastSearchSelected" (onChangeValue)="applySearch($event)"
                [placeholder]="'Ricerche recenti'" [data]="lastSearch" bindValue="_id"></std-select>
        </div>}
          
        <div class="flex gap-5  items-center">
            <div (click)="newFiltersToApply ? page = 1 :null;newFiltersToApply ? applyFilters() : null"
                class="w-fit cursor-pointer h-12 items-center px-[17px] flex gap-[5px] rounded-full border-[#283759] border-[2px] bg-[#D3E0FF]"
                [ngClass]="{'bg-[#FEEEEA] border-[#F15928]': newFiltersToApply}">
                @if(!newFiltersToApply){<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M21.6187 4.64346C21.5033 4.37675 21.312 4.14986 21.0686 3.99101C20.8253 3.83216 20.5406 3.74836 20.25 3.75002H3.74997C3.45966 3.7506 3.17575 3.8354 2.93269 3.99416C2.68962 4.15291 2.49785 4.37879 2.38063 4.64438C2.26341 4.90998 2.22579 5.20389 2.27232 5.49045C2.31886 5.77701 2.44755 6.04391 2.64279 6.25877L2.65029 6.26721L8.99998 13.0472V20.25C8.99991 20.5215 9.07353 20.7879 9.21297 21.0208C9.35241 21.2538 9.55246 21.4445 9.79178 21.5727C10.0311 21.7008 10.3007 21.7617 10.5719 21.7486C10.843 21.7356 11.1056 21.6493 11.3315 21.4988L14.3315 19.4981C14.5372 19.3612 14.7058 19.1755 14.8224 18.9576C14.939 18.7398 15 18.4965 15 18.2494V13.0472L21.3506 6.26721L21.3581 6.25877C21.5554 6.04489 21.6853 5.77764 21.7317 5.49037C21.778 5.2031 21.7387 4.90854 21.6187 4.64346ZM13.7043 12.2419C13.5746 12.3795 13.5016 12.5609 13.5 12.75V18.2494L10.5 20.25V12.75C10.5 12.5596 10.4276 12.3762 10.2975 12.2372L3.74997 5.25002H20.25L13.7043 12.2419Z"
                        fill="#283759" />
                </svg>
       
            
                <div class="text-[#283759] text-font18px whitespace-nowrap">Filtri {{numberOfFilters > 3 ?('(' + (numberOfFilters - 3) + ')' ): ''}}</div>}
                @if(newFiltersToApply){<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M21.6187 4.64346C21.5033 4.37675 21.312 4.14986 21.0686 3.99101C20.8253 3.83216 20.5406 3.74836 20.25 3.75002H3.74997C3.45966 3.7506 3.17575 3.8354 2.93269 3.99416C2.68962 4.15291 2.49785 4.37879 2.38063 4.64438C2.26341 4.90998 2.22579 5.20389 2.27232 5.49045C2.31886 5.77701 2.44755 6.04391 2.64279 6.25877L2.65029 6.26721L8.99998 13.0472V20.25C8.99991 20.5215 9.07353 20.7879 9.21297 21.0208C9.35241 21.2538 9.55246 21.4445 9.79178 21.5727C10.0311 21.7008 10.3007 21.7617 10.5719 21.7486C10.843 21.7356 11.1056 21.6493 11.3315 21.4988L14.3315 19.4981C14.5372 19.3612 14.7058 19.1755 14.8224 18.9576C14.939 18.7398 15 18.4965 15 18.2494V13.0472L21.3506 6.26721L21.3581 6.25877C21.5554 6.04489 21.6853 5.77764 21.7317 5.49037C21.778 5.2031 21.7387 4.90854 21.6187 4.64346ZM13.7043 12.2419C13.5746 12.3795 13.5016 12.5609 13.5 12.75V18.2494L10.5 20.25V12.75C10.5 12.5596 10.4276 12.3762 10.2975 12.2372L3.74997 5.25002H20.25L13.7043 12.2419Z"
                        fill="#F15928" />
                </svg>
                <div class="text-[#F15928] text-font18px whitespace-nowrap">Applica Filtri</div>
                }

            </div>
            @if(numberOfFilters > 3){
            <div class="text-[#283759] text-font18px font-medium cursor-pointer" (click)="resetFilters()">Reset</div>
            }
        </div>
    </div>
    
    <div class="w-full md:hidden gap-5 relative ml-auto items-end">

        <div class="flex gap-3 place-content-end md:place-content-center md:w-[300px]">
            <div class="text-font20px text-[#78909C] font-normal">Elementi per pagina</div>
            <div class="w-[60px]">
                <std-select customClassContaier="custom-select" customClassSubContaier="fix-element-page"
                    customClassContainerElement="pl-0" [elementPage]="true"
                    customClassContainerElement="max-h-[250px] overflow-y-scroll change-cammel-case custom-scrollbar"
                    [filterable]="false" bindLabel="limit" bindValue="limit" (onChangeValue)="changeLimit($event)"
                    [multiple]="false" [currentValue]="{limit:15}" [placeholder]="'Elementi per pagina'" [data]="[
                {limit:'15'},
                {limit:'30'},
                {limit:'50'},
                {limit:'100'},
            ]"></std-select>
            </div>
        </div>
    </div>


    @if(filteredNotices.length > 0){

    <div
        class="text-quaternary sm:flex place-content-between text-font22px aspect43:text-font32px font-semibold mx-auto max-w-[100%]">
        <div class="flex text-black text-font32px font-bold font-sans text-center sm:text-left">
            <span>{{count}} Bandi Trovati</span>
            @if(count > 0) {
            <div *ngIf="showLogout"
                (click)="donwloadBandi()"
                class="w-fit cursor-pointer h-12 items-center px-[17px] flex gap-[5px] rounded-full border-[#283759] border-[2px] bg-[#D3E0FF] ml-1 mr-4">
                <div class="text-[#283759] text-font18px whitespace-nowrap">Scarica Bandi</div>
            </div>
            }
        </div>
        <div class="hidden md:flex place-content-end w-fit gap-5 ml-auto">
            <div class="w-[260px] relative normalText">

                <std-select customClassContaier="custom-select"
                    customClassContainerElement="max-h-[250px] overflow-y-scroll change-cammel-case custom-scrollbar"
                    [filterable]="true" (onChangeValue)="newFiltersToApply = true;changeFilters($event,'order')"
                    [placeholder]="'Seleziona ordinamento'" [currentValue]="{value:1,label:'Apertura recente'}"
                    [data]="[{value:1,label:'Apertura recente'},{value:2,label:'Apertura meno recente'},{value:3,label:'Chiusura recente'},{value:4,label:'Chiusura meno recente'}]"
                    bindLabel="label" bindValue="value"></std-select>
            </div>
            <div class="w-[150px] relative">

                <std-select customClassContaier="custom-select"
                    customClassContainerElement="max-h-[250px] overflow-y-scroll change-cammel-case custom-scrollbar"
                    [filterable]="true" [currentValue]="{label:'Aperto'}"
                    (onChangeValue)="newFiltersToApply = true;changeFilters($event,'status')" [placeholder]="'Status'"
                    [data]="status" bindLabel="label" bindValue="label"></std-select>
            </div>

            <div class="w-[60px]">
                <std-select customClassContaier="custom-select" customClassSubContaier="fix-element-page"
                    [elementPage]="true"
                    customClassContainerElement="max-h-[250px] overflow-y-scroll change-cammel-case custom-scrollbar"
                    [filterable]="false" bindLabel="limit" bindValue="limit" (onChangeValue)="changeLimit($event)"
                    [multiple]="false" [currentValue]="{limit:15}" [placeholder]="'Elementi per pagina'" [data]="[
                    {limit:'15'},
                    {limit:'30'},
                    {limit:'50'},
                    {limit:'100'},
                ]"></std-select>
            </div>
        </div>


        <div class=" sm:mr-0 flex place-content-center sm:place-content-end mt-5 sm:mt-0">
            <std-paginator [current]="page" [total]="totalPages" (pageChange)="page = $event;applyFilters()">
                <img arrowLeft class="size-6 rotate-180" src="./assets/arrow-right.svg">
                <img arrowRight class="size-6" src="./assets/arrow-right.svg">
            </std-paginator>
        </div>
    </div>
    <div class="flex flex-wrap place-content-center mx-auto max-w-[100%] mt-5 gap-5 mb-10">
        @for (bando of filteredNotices; track $index) {
        <div class="w-full rounded-[20px] border-[2px] border-[#D3E0FF] bg-transparent p-[25px] cursor-pointer"
            (click)="goToBando(bando.slug)">
            <div class="flex gap-5">
                <div class="text-[#283759] font-semibold text-font24px leading-[26px]" [title]="bando.title">
                    {{bando.title}}</div>

            </div>
            <div class="text-[#719CFF] mt-5 leading-[26px] font-semibold text-font24px">
                {{bando.soggettoConcedente}}<br>

                <div class="md:flex gap-5 mt-10">
                    <div class="text-quaternary text-font18px">
                        <div class="text-font20px font-bold text-[#283759]">Inizio
                        </div>
                        <div class="text-[#364349] text-font20px font-normal">{{bando.startDate == '1/1/1970' ?'Da
                            stabilire' :bando.startDate}}</div>
                    </div>
                    <div class="text-quaternary text-font18px">
                        <div class="text-font20px font-bold text-[#283759]">Scadenza
                        </div>
                        <div class="text-[#364349] text-font20px font-normal">{{bando.endDate == '1/1/1970' ?'Fino ad
                            esaurimento fondi' :bando.endDate}}</div>
                    </div>
                    <div class="">
                        <div class="text-font20px font-bold text-[#283759]">Finalità</div>
                        <div class="text-[#364349] text-font20px font-normal">{{bando.obiettivoFinalita}}</div>
                    </div>
                </div>
                <!-- <div class="flex flex-wrap gap-[10px] mt-4 mb-2">@for (label of bando.labels.slice(0,8); track $index) {
                    <div style="box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.04);"
                        class="px-[14px]  rounded-[20px] border-[2px] border-[#D3E0FF] text-font16px h-[41px] bg-transparent text-[#283759] font-semibold flex items-center place-content-center">
                        {{label}}</div>
                    }
                </div> -->
            </div>
            <div class="font-bold text-[#283759] mt-4 text-font20px">Stato</div>
            <div
                class="text-white font-normal px-[24px] h-[30px] rounded-full bg-[#719CFF] flex items-center text-font20px w-fit justify-center">

                <div>{{bando.statusDesc}}</div>
            </div>

        </div>
        }
    </div>

    <!-- <div class="w-full flex gap-5 relative ml-auto">
       <div class="flex gap-3"><div class="text-font20px text-[#78909C] font-normal">Elementi per pagina</div> 
       <div class="w-[60px]">
        <std-select customClassContaier="custom-select"
        customClassSubContaier="fix-element-page"
        customClassContainerElement="pl-0"
        [elementPage]="true"
            customClassContainerElement="max-h-[250px] overflow-y-scroll change-cammel-case custom-scrollbar"
            [filterable]="false" bindLabel="limit" bindValue="limit" (onChangeValue)="changeLimit($event)"
            [multiple]="false" [currentValue]="{limit:15}"
            [placeholder]="'Elementi per pagina'" [data]="[
                {limit:'15'},
                {limit:'30'},
                {limit:'50'},
                {limit:'100'},
            ]"></std-select>
            </div></div> 
    </div> -->

    <div class="ml-auto flex place-content-center sm:place-content-end mb-10">
        @if(filteredNotices.length > 0){
        <std-paginator [current]="page" [total]="totalPages" (pageChange)="page = $event;scrollTop();applyFilters()">
            <img arrowLeft class="size-6 rotate-180" src="./assets/arrow-right.svg">
            <img arrowRight class="size-6" src="./assets/arrow-right.svg">
        </std-paginator>}
    </div>
    }
    @if(filteredNotices.length == 0){
    <div class="text-font60px text-quaternary font-bold pb-5 text-center">NESSUN BANDO TROVATO</div>
    }
    <div (click)="goToContacts()" class="cursor-pointer w-fit mx-auto bg-quintary text-white h-[39px] px-4 rounded-full flex items-center justify-center text-font16px font-bold">Non hai trovato il bando che cercavi? Segnalacelo!</div>
    <!-- @if(filteredNotices.length == 0){
<div
    class="text-quaternary font-kansas text-font22px aspect43:text-font32px font-semibold mt-[60px] aspect43:mt-[100px] mx-auto max-w-[100%]">
    Bandi in evidenza
</div>
<div class="flex flex-wrap place-content-center mx-auto max-w-[100%] mt-5 gap-5">
    @for (bando of showAllSuggestedBandi? suggestedBandi: suggestedBandi.slice(0,6); track $index) {
    <div class="w-full rounded-[30px] bg-Swhite shadow-xl p-[25px] cursor-pointer" (click)="goToBando(bando.id)">
        <div class="flex gap-5"><div class="font-kansas text-font24px aspect43:text-font32px font-semibold text-quaternary overflow-hidden text-ellipsis"
            [title]="bando.title">{{bando.title}}</div>
        <div class="border-green-400 bg-green-300 text-green-700 p-2 h-[30px] rounded-[8px] flex items-center font-bold ml-auto" [ngClass]="{'!border-red-400 !bg-red-300 !text-red-700': !bando.open}">{{bando.open ?'APERTO' : 'CHIUSO'}}</div>
        </div>
        <div
            class="mt-[10px] text-quaternary text-font16px aspect43:text-font18px overflow-y-scroll overflow-x-hidden custom-scroll-secondary">
            {{bando.soggettoConcedente}}<br>
            <span class="font-bold">Finalità:</span> {{bando.obiettivoFinalita}}
            <div class="flex flex-wrap gap-2 mt-4 mb-2">@for (label of bando.labels; track $index) {
                <div class="p-1 border-secondary border-[2px] rounded-[8px] text-font12px bg-primary text-white font-semibold">{{label}}</div>
                }
            </div>
        </div>
    
        <div class="mt-[10px] text-quaternary text-font16px"><span class="font-bold">Scadenza: </span>{{bando.endDate == '1-1-1970' ?'Fino ad esaurimento fondi' :bando.endDate}}</div>
    </div>
    }
</div>
<div class="text-center text-quaternary underline cursor-pointer text-font18px mt-5"
    (click)="showAllSuggestedBandi = !showAllSuggestedBandi">
    @if(!showAllSuggestedBandi && suggestedBandi.length > 6){Mostra altro}
    @if(showAllSuggestedBandi && suggestedBandi.length > 6 ){Mostra meno}
</div>} -->


    <!-- @if(filteredNotices.length == 0){
<div
    class="text-quaternary font-kansas text-font22px aspect43:text-font32px font-semibold mt-[60px] aspect43:mt-[140px] mx-auto max-w-[100%]">
    Bandi recenti
</div>
<div class="flex flex-wrap place-content-center mx-auto max-w-[100%] mt-5 gap-5">
    @for (bando of showAllRecentBandi? recentdBandi: recentdBandi.slice(0,6); track $index) {
    <div class="w-full rounded-[30px]  bg-Swhite shadow-xl p-[25px] cursor-pointer"
        (click)="goToBando(bando.id)">
        <div class="flex gap-5"><div class="font-kansas text-font24px aspect43:text-font32px font-semibold text-quaternary overflow-hidden text-ellipsis"
            [title]="bando.title">{{bando.title}}</div>
        <div class="border-green-400 bg-green-300 text-green-700 p-2 h-[30px] rounded-[8px] flex items-center font-bold ml-auto" [ngClass]="{'!border-red-400 !bg-red-300 !text-red-700': !bando.open}">{{bando.open ?'APERTO' : 'CHIUSO'}}</div>
        </div>
        <div
            class="mt-[10px] text-quaternary text-font16px aspect43:text-font18px overflow-y-scroll overflow-x-hidden custom-scroll-secondary">
            {{bando.soggettoConcedente}}<br>
            <span class="font-bold">Finalità:</span> {{bando.obiettivoFinalita}}
            <div class="flex flex-wrap gap-2 mt-4 mb-2">@for (label of bando.labels; track $index) {
                <div class="p-1 border-secondary border-[2px] rounded-[8px] text-font12px bg-primary text-white font-semibold">{{label}}</div>
                }
            </div>
        </div>
        <div class="mt-[10px] text-quaternary text-font16px"><span class="font-bold">Scadenza: </span>{{bando.endDate == '1-1-1970' ?'Fino ad esaurimento fondi' :bando.endDate}}</div>
    </div>
    }
</div>
<div class="text-center text-quaternary underline cursor-pointer text-font18px mt-5 mb-20 aspect43:mb-[142px]"
    (click)="showAllRecentBandi = !showAllRecentBandi">
    @if(!showAllRecentBandi && recentdBandi.length > 6){Mostra altro}
    @if(showAllRecentBandi && recentdBandi.length > 6){Mostra meno}
</div>} -->
    @if(oldFilters){
    <div (scroll)="$event.preventDefault()" (click)="oldFilters = null"
        class="fixed top-0 left-0  !w-screen h-[5000px] flex place-content-center bg-black bg-opacity-35">
        <div (click)="$event.stopPropagation()"
            class="min-w-[300px] h-fit mt-[200px] max-w-[95vw] bg-white rounded-[20px] shadow-xl p-[25px]">
            <div class="mb-5 font-semibold text-quaternary text-font24px font-kansas">Filtri selezionati</div>
            <div class="mb-5">
                @for (item of oldFilters.desc; track $index){
                <div><span class="font-bold">{{t(item.title)}}:</span> {{item.desc}}</div>
                }
            </div>
            <div class="flex gap-5 justify-between">
                <div (click)="oldFilters = null" style="box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.08);"
                    class="w-[165px] font-medium h-[43px] rounded-full bg-primary text-font18px cursor-pointer text-Swhite flex items-center place-content-center mt-10">
                    Annulla</div>
                <div (click)="applyFilters()" style="box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.08);"
                    class="w-[165px] font-medium h-[43px] rounded-full bg-primary text-font18px cursor-pointer text-Swhite flex items-center place-content-center mt-10">
                    Applica</div>
            </div>
        </div>
    </div>
    }
</div>